import { palette } from '@knowz/knowz-ui';
import { RemoteSourcesOptions } from '@uppy/remote-sources';

export type AvailableSources = Extract<
  NonNullable<RemoteSourcesOptions['sources']>[number],
  'Dropbox' | 'OneDrive' | 'Zoom' | 'Box' | 'GoogleDrive'
>;

const REMOTE_SOURCES: AvailableSources[] = [
  'Dropbox',
  'OneDrive',
  'Zoom',
  'Box',
];

const FILE_RESTRICTIONS = [
  'text/html',
  'text/plain',
  'application/pdf',
  'text/csv',
  'application/xml',
  'application/json',
  'text/markdown',
  'image/png',
  'image/jpeg',
  'image/jpeg',
  'image/gif',
  'image/webp',
] as const;

const MAPPED_COLORS_TO_EXTENSIONS: {
  [key in (typeof FILE_RESTRICTIONS)[number]]: string;
} = {
  'text/html':
    palette.light['Component colors/Utility/Indigo/utility-indigo-600'],
  'text/plain': palette.light['Component colors/Utility/Gray/utility-gray-700'],
  'application/pdf':
    palette.light['Component colors/Utility/Success/utility-success-600'],
  'text/csv':
    palette.light['Component colors/Utility/Success/utility-success-600'],
  'application/xml':
    palette.light['Component colors/Utility/Indigo/utility-indigo-600'],
  'application/json':
    palette.light['Component colors/Utility/Indigo/utility-indigo-600'],
  'text/markdown':
    palette.light['Component colors/Utility/Indigo/utility-indigo-600'],
  'image/png':
    palette.light['Component colors/Utility/Brand/utility-brand-600'],
  'image/jpeg':
    palette.light['Component colors/Utility/Brand/utility-brand-600'],
  'image/gif':
    palette.light['Component colors/Utility/Brand/utility-brand-600'],
  'image/webp':
    palette.light['Component colors/Utility/Brand/utility-brand-600'],
};

const MAX_FILE_SIZE = {
  notPaid: 10 * 1024 * 1024, // 10MB
  paid: 30 * 1024 * 1024, // 30MB
};

const CONFIG = {
  REMOTE_SOURCES,
  MAPPED_COLORS_TO_EXTENSIONS,
  MAX_FILE_SIZE,
  FILE_RESTRICTIONS,
} as const;

export default CONFIG;
